  <div class="modal-header bg-light d-flex justify-content-center">
      <h4 class="modal-title strong" >
       {{ 'home.quote.Cancelbid' | cxTranslate }}
      </h4>
  </div>
      <div class="modal-body bg-light text-center">{{ 'home.quote.Thiscancel' | cxTranslate }}</div>
    <div class="modal-footer bg-light border-0">
      <div class="w-100">
        <button class="btn btn-block btn-danger btn-lg" type="submit" data-dismiss="modal" (click)="cancelbid()">
          {{ 'home.quote.Icancel' | cxTranslate }}
        </button>
        <button class="btn btn-block btn-secondary btn-lg" type="submit" data-dismiss="modal" (click)="close()">
          {{ 'home.quote.Close' | cxTranslate }}
        </button>
      </div>
    </div>


